import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjetoFeiraService } from '../../../../projects/services/projeto-feira.service';
import { DocumentoService } from '../../../services/documento.service';

@Component({
  selector: 'app-status-documento',
  templateUrl: './status-documento.component.html',
  styleUrl: './status-documento.component.scss'
})
export class StatusDocumentoComponent implements OnInit {
  @Input() projetoId = '';
  @Input() codumentoId = '';
  @Input() tipoDocumento = '';
  @Input() statusDocumento = '';

  documentoForm!: FormGroup
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private documentoService: DocumentoService) { }

  ngOnInit(): void {
    this.documentoForm = this.fb.group({
      projetoId: [this.projetoId],
      documentoId: [this.codumentoId],
      statusDocumento: [this.statusDocumento, Validators.required],
      tipoDocumento: [this.tipoDocumento]
    })
  }

  AtualizarDocumento(): void {

    if (!this.documentoForm.valid) {
      this.documentoForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    const documentoValues = this.documentoForm.value;

    //console.log(Number(documentoValies.statusDocumento));

    this.documentoService.atualizarProjetoDocumento(
      documentoValues.projetoId,
      documentoValues.documentoId,
      parseInt(documentoValues.statusDocumento),
      documentoValues.tipoDocumento).subscribe({
        next: (response) => {
          console.log('resposta', response);
        }
      })

    this.isLoading = false;
  }
}
